(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('snrs-gallery-counter')) {
  customElements.define('snrs-gallery-counter', class extends HTMLElement {
    connectedCallback() {
      this.carousel = this.closest('product-gallery').querySelector('scroll-carousel');
      if (!this.carousel) return;
      this.update = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const slides = [...this.carousel.querySelectorAll('.product-gallery__media')].filter(slide => !slide.hidden);
          const bounds = this.carousel.getBoundingClientRect();
          const center = bounds.left + bounds.width / 2;
          let selected = 0, distance = Infinity;
          slides.forEach((slide, index) => {
            const rect = slide.getBoundingClientRect();
            const next = Math.abs(rect.left + rect.width / 2 - center);
            if (next < distance) { selected = index; distance = next; }
          });
          this.textContent = '(' + (selected + 1) + '/' + slides.length + ')';
          this.hidden = slides.length < 2;
        });
      };
      this.carousel.addEventListener('scroll', this.update, { passive: true });
      this.carousel.addEventListener('carousel:change', this.update);
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this.carousel, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.carousel);
      this.update();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.carousel?.removeEventListener('scroll', this.update);
      this.carousel?.removeEventListener('carousel:change', this.update);
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snrs-complete-the-look"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('snrs-look-carousel')) {
    customElements.define('snrs-look-carousel', class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.snrs-complete-look__list');
        this.controls = this.querySelector('.snrs-complete-look__controls');
        if (!this.list || !this.controls) return;
        this.previous = this.querySelector('[data-look-direction="previous"]');
        this.next = this.querySelector('[data-look-direction="next"]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.desktop = matchMedia('(min-width: 700px)');
        const update = () => {
          const maximum = this.list.scrollWidth - this.list.clientWidth;
          const position = Math.abs(this.list.scrollLeft);
          this.controls.hidden = !this.desktop.matches || maximum <= 1;
          this.previous.disabled = position <= 1;
          this.next.disabled = position >= maximum - 1;
        };
        this.list.addEventListener('scroll', update, { ...options, passive: true });
        this.desktop.addEventListener('change', update, options);
        this.controls.addEventListener('click', event => {
          const button = event.target.closest('[data-look-direction]');
          if (!button || button.disabled) return;
          const tile = this.list.firstElementChild;
          const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
          const direction = button.dataset.lookDirection === 'next' ? 1 : -1;
          const rtl = getComputedStyle(this.list).direction === 'rtl' ? -1 : 1;
          this.list.scrollBy({
            left: (tile.getBoundingClientRect().width + gap) * direction * rtl,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        }, options);
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.list);
        update();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snrs-product-info-boxes"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-snrs-info-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!dialog || dialog.open) return;
      const units = dialog.querySelector('.sin-size-guide-units');
      const table = dialog.querySelector('.sin-size-guide-content table');
      const chartHeading = dialog.querySelector('.snrs-fit-panel-section__chart-title');
      if (table && chartHeading) table.before(chartHeading);
      if (units && table) table.after(units);
      dialog.querySelectorAll('.sin-size-guide-content td').forEach((cell) => {
        const millimetres = cell.textContent.trim().match(/^(\d+(?:\.\d+)?)\s*MM$/i);
        if (millimetres && !cell.dataset.measureCm) cell.dataset.measureCm = String(Number(millimetres[1]) / 10);
      });
      if (typeof window.sinSetGuideUnit === 'function') window.sinSetGuideUnit(dialog, 'cm');
      dialog.showModal();
      return;
    }
    const closeButton = event.target.closest('[data-snrs-info-close]');
    if (closeButton) closeButton.closest('dialog').close();
    if (event.target.matches('.snrs-info-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
